export default "__VITE_ASSET__BbA8HeFa__"